import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, TextField, InputAdornment, Chip, FormControlLabel, Box, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { Search as SearchIcon, Close as CloseIcon, Add as AddIcon } from '@mui/icons-material';
import { fetchGet, fetchPost, getRandomNumber, getOutreachCreatorLink, getStringHash } from '../util/helpers';
import toast from "react-hot-toast";
import { IconArrowLeft } from '@tabler/icons-react';
import OutreachDrawer from './OutreachDrawer';

function InviteFromListDialog({open, onClose, campaignId}) {
    const [myList, setMyList] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedCreators, setSelectedCreators] = useState([]);
    const [selectedMyList, setSelectedMyList] = useState(null);
    const [confirmCreatorCardOpen, setConfirmCreatorCardOpen] = useState(false);
    const [creatorData, setCreatorData] = useState(null);
    const [customText, setCustomText] = useState("");
    const handleListSelection = (platform) => {
        setSelectedMyList(platform);
      }

      const sendEmail = () => {
        for(let creator of selectedCreators){
        const body = {
          campaignId: campaignId,
          email: creator.email,
        };
        if (customText.trim()) {
          body.text = customText;
        }
        fetchPost(`/brand/outreach`, body)
          .then(() => {
            toast.success(
              `Successfully sent an email to ${creator}. Check the status of this email in your outreach table.`,
            );
            onClose();
            setCustomText("");
          })
          .catch(() => {
            toast.error(
              `Failed to send an email to ${creator}. Please check back later.`,
            );
          });
        }
      };
      const fetchMyList = () => {
        fetchGet(`/brand/lists`)
        .then((result) => result.result)
        .then((result) => {
          setMyList(result)
        })
      }
      useEffect(() => {
        fetchMyList();
      }, [])
    return (
      <>
      <OutreachDrawer open={confirmCreatorCardOpen} onClose={() => setConfirmCreatorCardOpen(false)} creator={creatorData} />
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>{
            selectedMyList ?<>
            <DialogTitle> <div className="dialog-header">
            <IconArrowLeft style={{cursor: "pointer", marginRight: 5}} onClick={() => {
              setSelectedMyList(null)
              setSelectedCreators([])
            }}/>
            <div className="title-main">
            Invite From: {selectedMyList.name}
            </div>
            <div className="title-sub">
              ({selectedMyList.creators.length} Creators)
            </div> 
          </div>
          
          </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        
        <DialogContent dividers>
            
          <div className="my-list-content">
           

            {
              selectedMyList.creators.map((creator, index) => {
                return <div key={index} >
                   <div className={`checkbox-container`}> 
                   <Box display="flex" flexDirection="row" gap={2} alignItems="center">
                    <FormControlLabel
                    key={index}
                    control={
                      <input type="checkbox" className="checkbox" checked={selectedCreators.includes(creator)} value={creator} onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedCreators(prev => [...prev, creator])
                        } else {
                          setSelectedCreators(prev => prev.filter(c => c !== creator))
                        }
                      }} />
                    }
                    label={<img
                      className="profile-image-large"
                      src={
                        creator?.profileImage
                          ? creator?.profileImage
                          : `../gradient${getStringHash(creator?.name, 10)}.png`
                      }
                      alt={creator.name}
                    />}
                   
                  />
                    <Link href={getOutreachCreatorLink(creator)} target="_blank" rel="noopener noreferrer">{creator.name}</Link>
                    </Box>
                    <Button variant="outlined"
                            color="info"
                            size="small"
                            style={{ height: 30, width: 100, marginLeft: "auto"}}
                            onClick={() => {
                      setCreatorData(creator)
                      setConfirmCreatorCardOpen(true)
                    }}>View Profile</Button>

                </div>
                </div>

              })
            }

         
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="custom-button" onClick={() => { setCustomText(""); onClose(); }}>Cancel</Button>
          <Button className="custom-button grd-bg-btn" onClick={sendEmail}>Send Invite</Button>
        </DialogActions>
            </> :
            <><DialogTitle> <div className="dialog-header">
            <div className="title-main">
            Invite From My List
            </div>
            <div className="title-sub">
              ({myList.length} List Available)
            </div> 
          </div></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <div className="my-list-content">
            <TextField
              fullWidth
              className="name-search"
              onChange={(e) => {
              }}
              sx={{marginBottom:"1rem"}}
              size="small"
              placeholder="Search Lists..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{
                      fontSize: "20px"
                    }} />
                  </InputAdornment>
                ),
              }}
            />


            {
              myList.map((platform, index) => {
                return <div key={index} >
                  <Box
                  onClick={() => handleListSelection(platform)}
                  justifyContent="space-between"
                  style={{cursor: "pointer", border: "1px solid #D0D5DD", borderRadius: "6px", padding: 8}} display="flex" alignItems="center" width="100%" className={`checkbox-container`}> { platform.name || platform} 
                  <Chip 
                  size="small"
                  sx={{
                    backgroundColor: '#F2F4F7'
                  }} label={`${platform.creators.length} Creators`} />
                  </Box>
                </div>

              })
            }

         
          </div>
        </DialogContent>
       </>
        }
        
      </Dialog>
      </>
    );
}

export default InviteFromListDialog;